import React from 'react'
import styled from 'styled-components'

import { NoData } from 'styles/shared'

import Brand from 'helpers/brand'
import { color } from 'styles/colors'

const NotEnrolled = () => (
  <S.Container>
    <S.NoData>
      <h1>NOT ENROLLED</h1>
      <h2>{`Device details cannot be displayed because this device has not been enrolled to the customer's ${Brand.brandName().toUpperCase()} home account`}</h2>
      <S.InfoText>Please reach out to the customer to have them connect this device to their Home account.</S.InfoText>
    </S.NoData>
    <S.ImgContainer>
      <S.InstructionsImg
        src={Brand.isASAirHome() ? '/img/as_not_enrolled.png' : '/img/trane_not_enrolled.png'}
        alt="not-enrolled-instruction"
      />
    </S.ImgContainer>
  </S.Container>
)

export default NotEnrolled

const S = {
  Container: styled.div`
    padding: 0 10px 0;
  `,
  NoData: styled(NoData)`
    padding: 2em 0 2em 0;
  `,
  InfoText: styled.h3`
    padding-top: 20px;
    color: ${color('primaryText')};
  `,
  ImgContainer: styled.div`
    margin: 0 auto;
    margin-bottom: 20px;
    justify-content: center;
    max-height: 870px;
    max-width: 1023px;
  `,
  InstructionsImg: styled.img`
    max-width: 100%;
    height: auto;
    background-size: contain;
  `
}
